import React from 'react';

const Logo = ({ size = 'default' }) => {
  const sizes = {
    small: { text: 'text-xl', icon: 'w-6 h-6' },
    default: { text: 'text-2xl', icon: 'w-8 h-8' },
    large: { text: 'text-4xl', icon: 'w-12 h-12' }
  };

  const currentSize = sizes[size] || sizes.default;

  return (
    <div className="flex items-center gap-2">
      {/* Claw Icon */}
      <div className={`${currentSize.icon} relative`}>
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Claw shape with gradient */}
          <defs>
            <linearGradient id="clawGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ff4d4d" />
              <stop offset="50%" stopColor="#ff6b6b" />
              <stop offset="100%" stopColor="#ff8585" />
            </linearGradient>
            <filter id="glow">
              <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
              <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          {/* Main claw body */}
          <ellipse cx="20" cy="25" rx="12" ry="10" fill="url(#clawGradient)" filter="url(#glow)"/>
          {/* Left pincer */}
          <path d="M8 15 Q5 10, 8 5 Q12 8, 14 12 Q10 14, 8 15Z" fill="url(#clawGradient)" filter="url(#glow)"/>
          {/* Right pincer */}
          <path d="M32 15 Q35 10, 32 5 Q28 8, 26 12 Q30 14, 32 15Z" fill="url(#clawGradient)" filter="url(#glow)"/>
          {/* Eyes */}
          <circle cx="16" cy="22" r="2" fill="#050810"/>
          <circle cx="24" cy="22" r="2" fill="#050810"/>
          <circle cx="16.5" cy="21.5" r="0.8" fill="white"/>
          <circle cx="24.5" cy="21.5" r="0.8" fill="white"/>
        </svg>
      </div>
      {/* Text */}
      <span className={`${currentSize.text} font-bold`}>
        <span className="text-white">Claw</span>
        <span className="bg-gradient-to-r from-[#ff4d4d] to-[#ff6b6b] bg-clip-text text-transparent">9</span>
        <span className="text-white/60">.ai</span>
      </span>
    </div>
  );
};

export default Logo;
